import { type ChangeEvent, type FocusEvent, type ReactNode } from 'react'
import cn from 'classnames'

interface FormFieldProps {
  additionalOuterClasses?: string
  label?: string
  minDate?: string
  maxDate?: string
  preLabel?: string
  placeholder?: string
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur: (e: FocusEvent<HTMLInputElement>) => void
  showError?: boolean
  errorMessage?: string
  children?: ReactNode
}

export const StandardDateInput: React.FC<FormFieldProps> = ({
  additionalOuterClasses,
  label,
  minDate,
  maxDate,
  preLabel,
  placeholder,
  value,
  onChange,
  onBlur,
  showError,
  errorMessage,
  children
}) => {
  return (
    <div className={cn(additionalOuterClasses, 'flex flex-col w-full mx-2')}>
      <label>{label}</label>
      <div className="relative">
        {preLabel && (
          <div className="absolute left-4 top-1 text-lg">{preLabel}</div>
        )}
        <input
          onKeyDown={(e) => { e.preventDefault() }}
          min={minDate}
          max={maxDate}
          type="date"
          className={cn('py-2 text-left w-full h-full border rounded-md',
            showError ? 'border-red-500' : ' border-wpy-gray',
            preLabel ? 'pl-8' : 'pl-4')}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        {showError && <div className="absolute left-0.5 top-1 text-lg text-red-500">❗</div>}
      </div>
      <div className="h-6 text-sm text-red-500">{errorMessage}</div>
      {children}
    </div>
  )
}
